let last_name = {};

last_name = require('../data/last_name')

module.exports = last_name;